import logger from './logger';
import React, { useEffect, useState } from 'react';
import '../style/PDFModalClaimForm.css'; // Make sure you have modal styles or include inline styles

const PDFModalClaimForm = ({ clinic_note_id, id, onClose }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;
  // logger.log("PDFModalViewer clinic note id: ", clinic_note_id)
  useEffect(() => {
    const fetchPDF = async () => {
      try {
        const pdfName = `HealthHub_${clinic_note_id}_${id}_clinic_notes.pdf`
        const res = await fetch(`${BASE_URL}/upload/generate-signed-url?pdfName=${pdfName}`);
        const data = await res.json();
        // logger.log(data)
        setPdfUrl(data.signedUrl); // This must be a public or signed URL
      } catch (error) {
        logger.error('Error fetching PDF:', error);
      }
    };
    if (clinic_note_id) fetchPDF();
  }, [clinic_note_id]);

  if (!clinic_note_id) return null;

  // return (
  //   <div className="pdf-modal-overlay">
  //     <div className="pdf-modal-content">
  //       <button className="pdf-close-button" onClick={onClose}>✖</button>
  //       {pdfUrl ? (
  //         <iframe
  //           src={pdfUrl}
  //           title="PDF Viewer"
  //           className="pdf-modal-element"
  //         />
  //       ) : (
  //         <p>Loading PDF...</p>
  //       )}
  //     </div>
  //   </div>
  // );
  return (
  <div className="new-pdf-modal-overlay open">
    <div className="new-pdf-modal-content">
      <button className="new-pdf-close-button" onClick={onClose}>✖</button>
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          width="100%"  // ← Fix: use 100% not 300%
          height="100%"
          className="new-pdf-modal-element"
        />
      ) : (
        <p>Loading PDF...</p>
      )}
    </div>
  </div>
);

};

export default PDFModalClaimForm;